import alertify from "alertifyjs";
import axios from "axios";
import React, { useState } from "react";
import { useHistory } from "react-router";
import APIModel from "../../Models/APIModel";
import {
  displayAlertifyError,
  displayAlertifySuccess,
} from "../../util/functions";
import {
  Input,
  InputAdornment,
  FormControl,
  IconButton,
} from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";

const ResetPassword = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const history = useHistory();
  const get_email = localStorage.getItem("user_email");
  const [password, setPassword] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const handleChangePassword = (e) => {
    setPassword({ ...password, [e.target.name]: e.target.value });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (password.newPassword !== password.confirmPassword)
      displayAlertifyError({
        error: "New password and confirm password must match",
      });
    else {
      const params = { email: get_email, password: password.newPassword };
      console.log(params);
      axios
        .post(APIModel.HOST + "reset-password", params, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((res) => {
          displayAlertifySuccess({ message: res.data.message });
          setTimeout(() => {
            history.push("/");
          }, 500);
        })
        .catch((err) => console.log(err));
    }
  };
  return (
    <>
      <main className="">
        <div className="container-fluid container-login">
          <div
            className="row justify-content-center align-items-center"
            style={{ height: "100vh" }}
          >
            <div className="col-12 col-md-7 col-xl-5">
              <div className="card card-signin my-5">
                <div div className="card-header card-header-primary">
                  <h4 className="card-title text-center">Reset password</h4>
                </div>
                <div className="card-body">
                  <div className="logo text-center mb-3">
                    <img
                      src={process.env.PUBLIC_URL + "/logo.png"}
                      alt="Logo"
                      className="logo"
                    />
                  </div>
                  <form onSubmit={handleSubmit}>
                    <input
                      type="hidden"
                      name="_token"
                      defaultValue="hLuKijK86fLz0Xp4rJoK4Rzxu9jXz25VZF9dJ4mP"
                    />
                    {/* <div className="row">
                      <div className="col-12">
                        <div className="form-group">
                          <input
                            type="password"
                            className="form-control input-box"
                            name="newPassword"
                            value={password.newPassword}
                            onChange={handleChangePassword}
                            placeholder="Enter new password"
                            autoFocus
                            required
                          />
                        </div>
                      </div>
                    </div> */}

                    {/* <div className="row">
                      <div className="col-12">
                        <div className="form-group">
                          <input
                            type="password"
                            className="form-control input-box"
                            name="confirmPassword"
                            value={password.confirmPassword}
                            onChange={handleChangePassword}
                            placeholder="Enter confirm password"
                            autoFocus
                            required
                          />
                        </div>
                      </div>
                    </div> */}

                    <div className="row">
                      <div className="col-12">
                        <FormControl
                          sx={{ m: 1 }}
                          variant="standard"
                          style={{ width: "100%" }}
                          className="form-group"
                        >
                          <label
                            className="bmd-label-floating"
                            htmlFor="password"
                          >
                            New Password
                          </label>
                          <Input
                            style={{ marginTop: "-.2rem" }}
                            id="password"
                            name="newPassword"
                            value={password.newPassword}
                            onChange={handleChangePassword}
                            type={showPassword ? "text" : "password"}
                            endAdornment={
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={() =>
                                    setShowPassword((prev) => !prev)
                                  }
                                >
                                  {showPassword ? (
                                    <VisibilityOff />
                                  ) : (
                                    <Visibility />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            }
                          />
                        </FormControl>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <FormControl
                          sx={{ m: 1 }}
                          variant="standard"
                          style={{ width: "100%" }}
                          className="form-group"
                        >
                          <label
                            className="bmd-label-floating"
                            htmlFor="password"
                          >
                            Confirm Password
                          </label>
                          <Input
                            style={{ marginTop: "-.2rem" }}
                            id="confirmPassword"
                            name="confirmPassword"
                            value={password.confirmPassword}
                            onChange={handleChangePassword}
                            type={showConfirmPassword ? "text" : "password"}
                            endAdornment={
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={() =>
                                    setShowConfirmPassword((prev) => !prev)
                                  }
                                >
                                  {showConfirmPassword ? (
                                    <VisibilityOff />
                                  ) : (
                                    <Visibility />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            }
                          />
                        </FormControl>
                      </div>
                    </div>

                    <div className="mt-2">
                      <button type="submit" className="btn btn-primary">
                        <b>Reset Password</b>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default ResetPassword;
